import {TiThMenu} from 'react-icons/ti';
import styled from 'styled-components';
import {fadeIn} from '../../utils/styles/animation';

export const NavBar = styled.nav`
  background-color: var(--BackgroundColor);
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.03);
`;

export const NavBarWrapper = styled.nav`
  display: flex;
  padding-top: 10px;
  justify-content: space-between;

  @media (max-width: 950px) {
    display: none;
  }
  @media (max-width: 1323px) {
    margin: 0 10px;
  }
`;

export const NavLeft = styled.div`
  display: flex;
`;

export const NavRight = styled.div`
  display: flex;
  align-items: center;
`;

export const MobileWrapper = styled.div`
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  display: flex;

  @media (min-width: 950px) {
    display: none;
  }
`;

export const MenuIcon = styled(TiThMenu)`
  color: var(--DarkGray);
  cursor: pointer;
  font-size: 25px;
`;

export const MobileMenu = styled.div`
  position: relative;
`;

export const MobileHide = styled.div`
  top: 70%;
  left: 0%;
  z-index: 9999;
  display: none;
  min-width: 290px;
  margin-top: 10px;
  position: absolute;
  border-radius: 8px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: var(--BackgroundColor);
  box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.19);
  ${fadeIn({time: '250ms', type: 'ease'})}

  ${MobileMenu}:hover & {
    display: flex;
  }
`;
